import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Owners } from 'components/common';
import {
  Box,
  BoxEmpty,
  BoxTable,
  BoxTableCell,
  BoxTableHeader,
  BoxTableRow
} from 'components/common/box';
import {
  AnswersProgress,
  CompletionStatus,
  ReadingProgress,
  TaskPointsProgress,
  VideoProgress
} from 'components/common/tasks';
import { CourseTitleWithInfo } from 'components/courses/common';

const UserCourses = ({ courses, currentUser, hideBoxTitle = false }) => {
  const { messages } = useReduxState();

  return (
    <div className="courses">
      <Box padding={0} title={hideBoxTitle ? null : messages.usersCourses}>
        {courses && courses.length ? (
          <BoxTable>
            <BoxTableHeader hideAtBreakpoint={breakpoints.medium}>
              <BoxTableCell>{messages.commonCourse}</BoxTableCell>
              <BoxTableCell>{messages.tasksReading}</BoxTableCell>
              <BoxTableCell>{messages.tasksVideos}</BoxTableCell>
              <BoxTableCell>{messages.tasksAnswers}</BoxTableCell>
              <BoxTableCell>{messages.tasksTaskPoints}</BoxTableCell>
              <BoxTableCell>{messages.commonCompleted}</BoxTableCell>
            </BoxTableHeader>

            {courses.map((course) => (
              <BoxTableRow
                as={`/users/${currentUser.id}/courses/${course.id}`}
                key={course.id}
                href="/users/[userId]/courses/[courseId]"
              >
                <BoxTableCell cellBreakpoint={breakpoints.medium}>
                  <CourseTitleWithInfo course={course}>
                    <Owners owners={course.owners} />
                  </CourseTitleWithInfo>
                </BoxTableCell>

                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.tasksReading}
                  shrink={true}
                >
                  <ReadingProgress
                    analyticsDisabledForAdmin={course.analyticsDisabledForAdmin}
                    discrepancyInCompletion={
                      course.discrepancyInCompletion?.readingProgress
                    }
                    readingProgress={course.readingProgress}
                    readingProgressMaxTime={course.readingProgressMaxTime}
                  />
                </BoxTableCell>

                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.tasksVideos}
                  shrink={true}
                >
                  <VideoProgress
                    analyticsDisabledForAdmin={course.analyticsDisabledForAdmin}
                    discrepancyInCompletion={
                      course.discrepancyInCompletion?.videoProgress
                    }
                    numberOfVideos={course.numberOfVideos}
                    videoProgress={course.videoProgress}
                    videosWatched={course.videoProgressVideosWatched}
                  />
                </BoxTableCell>

                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.tasksAnswers}
                  shrink={true}
                >
                  <AnswersProgress
                    numberOfAnswers={course.numberOfAnswers}
                    numberOfTasks={course.numberOfTasks}
                  />
                </BoxTableCell>

                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.tasksTaskPoints}
                  shrink={true}
                >
                  <TaskPointsProgress
                    discrepancyInCompletion={
                      course.discrepancyInCompletion?.taskPointsProgress
                    }
                    numberOfTasks={course.numberOfTasks}
                    taskMaxPoints={course.taskMaxPoints}
                    taskPoints={course.taskPoints}
                    taskPointsProgress={course.taskPointsProgress}
                  />
                </BoxTableCell>

                <BoxTableCell
                  cellBreakpoint={breakpoints.medium}
                  label={messages.commonCompleted}
                >
                  <CompletionStatus
                    completion={course.completion}
                    course={course}
                    discrepancyInCompletion={course.discrepancyInCompletion}
                  />
                </BoxTableCell>
              </BoxTableRow>
            ))}
          </BoxTable>
        ) : (
          <BoxEmpty text={messages.commonNoCourses} />
        )}
      </Box>
    </div>
  );
};

export default UserCourses;
